import { Component, OnInit } from '@angular/core';
import { AlertPaymentService } from '../shared/services/alert-payment.service';

@Component({
  selector: 'cc-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
  public failedPayment: boolean;
  constructor(public alertPaymentService: AlertPaymentService) {}

  ngOnInit() {
    this.alertPaymentService.onActivatePaymentAlert.subscribe(isPaymentFailed => {
      this.failedPayment = isPaymentFailed;
    });
  }
}
